import React from 'react';
import PropTypes from 'prop-types';
import connectStore from 'decorators/connectStore';
import AccountStore from 'stores/AccountStore';
import I18nActionCreator from 'actions/I18nActionCreator';
import PreferenceActionCreator from 'actions/PreferenceActionCreator';

import NavLink from 'components/nav/shared/NavLink';
import MobileMenuBack from 'components/nav/shared/MobileMenuBack';
import { defaultMenu } from 'components/nav/shared/MobileMenuController';
import Locale from 'utils/Locale';

@connectStore(AccountStore, 'accountState')
class LanguageMenuContainer extends React.Component {
  render() {
    return (
      <LanguageMenu {...this.props} />
    );
  }
}

class LanguageMenu extends React.Component {
  static propTypes = {
    accountState: PropTypes.object.isRequired,
    transitionToMenu: PropTypes.func.isRequired,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static menuName = 'language'

  constructor(props) {
    super(props);
    this.handleBackClick = this.handleBackClick.bind(this);
  }

  handleBackClick() {
    this.props.transitionToMenu(defaultMenu);
  }

  handleLocaleSelect = locale => (event) => {
    event.preventDefault();
    if (this.props.accountState
      && this.props.accountState.account && this.props.accountState.account.customerId) {
      const { customerId } = this.props.accountState.account;
      PreferenceActionCreator.updatePreference(customerId, { locale });
    }
    I18nActionCreator.changeLocale(locale);
  }

  renderSortedNavLinks() {
    const { getString } = this.context;
    const localeStringToLocaleMap = {};

    Locale.getAvailableLocales().forEach((locale) => {
      const localeString = getString(Locale.buildLocaleStringId(locale));
      localeStringToLocaleMap[localeString] = locale;
    });

    const sortedLocaleStrings = Object.keys(localeStringToLocaleMap)
      .sort((left, right) => left.localeCompare(right));

    return sortedLocaleStrings.map((localeString) => {
      const locale = localeStringToLocaleMap[localeString];
      return (
        <li key={localeString}>
          <NavLink
            to="#"
            stringID={Locale.buildNativeLocaleStringId(locale)}
            clickHandler={this.handleLocaleSelect(locale)}
          />
        </li>
      );
    });
  }

  render() {
    return (
      <ul className="nav navbar-nav">
        <li><MobileMenuBack callback={this.handleBackClick} stringID="AA_Main_Menu" /></li>
        {this.renderSortedNavLinks()}
      </ul>
    );
  }
}

export default LanguageMenuContainer;
